<div
    data-cy="filterbar"
    class="search-container"
    *ngIf="!isShowSimpleFilter() && filterbarLabels.length > 0"
>
    <div
        class="search-box"
        *ngFor="let filterbarLabel of filterbarLabels; index as i"
        [ngClass]="{
            divider: i !== filterbarLabels.length - 1
        }"
    >
        <app-labelled-block-input-wrapper [header]="filterbarLabel.header">
            <input
                type="text"
                class="text"
                #wrapTarget
                [(ngModel)]="filterOption[filterbarLabel?.model]"
                (ngModelChange)="onChangeEmit(filterbarLabel?.model, $event)"
                (focus)="showSearchDivider = false"
                (blur)="showSearchDivider = true"
                [placeholder]="filterbarLabel.placeholder"
            />
        </app-labelled-block-input-wrapper>
    </div>
    <div
        class="search-button-container"
        (click)="onSearchClick(); dataFilter()"
    >
        <button data-cy="search-bar-submit-button" class="primary">
            <mat-icon
                style="width: 20px; height: 20px"
                svgIcon="search"
            ></mat-icon>
        </button>
    </div>
</div>

<div class="search-input-container" *ngIf="isShowSimpleFilter()">
    <div class="search-box">
        <app-input-search-wrapper>
            <input
                type="text"
                class="text"
                #wrapTarget
                (focus)="showSearchDivider = false"
                (blur)="showSearchDivider = true"
                [placeholder]="
                    simpleFilterLabel?.placeholder
                        ? simpleFilterLabel.placeholder
                        : ''
                "
                [(ngModel)]="filterOption[simpleFilterLabel?.model]"
                (ngModelChange)="onChangeEmit(simpleFilterLabel?.model, $event)"
            />
        </app-input-search-wrapper>
    </div>
</div>
